import { createFileRoute } from '@tanstack/react-router';

import { BeFoundPage } from '@/features/me/talent-pages';

export const Route = createFileRoute('/_app/me/work/listing')({ component: BeFoundPage });
